import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { type AsChildProps, Slot } from "@/components/_molecules/slot.tsx";
import { useDeleteLabelGroup } from "@/domain/label/hooks/api/use-delete-label-group";

type DeletLabelGroupActionProps = AsChildProps<React.ButtonHTMLAttributes<HTMLButtonElement>> & {
  style?: React.CSSProperties;
  className?: string;
  labelGroup: {
    id: string;
  };
  workspace: {
    id: string;
  };
  forceDelete?: boolean;
};

export const DeleteLabelGroupAction = ({ labelGroup, asChild, forceDelete, ...props }: DeletLabelGroupActionProps) => {
  const { t } = useTranslation("common");
  const Comp = asChild ? Slot : "button";

  const { deleteLabelGroup } = useDeleteLabelGroup({
    onCompleted: () => {
      toast.success(t("label.deleteSuccess"), { description: t("label.deleteSuccessDescription") });
    },
    onError: () => {
      toast.error(t("label.deleteError"), { description: t("label.deleteError") });
    },
  });

  useEffect(() => {
    if (forceDelete) {
      triggerDeleteLabel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceDelete]);

  async function triggerDeleteLabel() {
    await deleteLabelGroup({ id: labelGroup.id });
  }

  function handleClick() {
    triggerDeleteLabel();
  }

  return <Comp {...props} onClick={handleClick} />;
};
